import {NgModule, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {AuthGuard} from './components/common/auth/auth.guard';


import { HallListComponent } from './pages/hall-list/hall-list.component';
import { ExhibitorsComponent } from './pages/exhibitors/exhibitors.component';
import { ProductsComponent } from './pages/products/products.component';
import { NoveltiesComponent } from './pages/novelties/novelties.component';
import { BrandsComponent } from './pages/brands/brands.component';
import { MapsComponent } from './pages/maps/maps.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { MyFavoritesComponent } from './pages/my-favorites/my-favorites.component';
import { CardDetailComponent } from './pages/card-detail/card-detail.component';
import { CardDetailProductComponent } from './pages/card-detail-product/card-detail-product.component';
import { HomeComponent } from './components/home/home.component';
import { ExhibitorBackofficeUtilInfoComponent } from './pages/exhibitor-backoffice-util-info/exhibitor-backoffice-util-info.component';
import { ContactComponent } from './pages/contact/contact.component';
import { GeneralInformationComponent } from './pages/general-information/general-information.component';
import { ExhibitorBackofficeExhibitorDetailEditComponent } from './pages/exhibitor-backoffice-exhibitor-detail-edit/exhibitor-backoffice-exhibitor-detail-edit.component';
import { ExhibitorBackofficeExhibitorsComponent } from './pages/exhibitor-backoffice-exhibitors/exhibitor-backoffice-exhibitors.component';
import { ExhibitorBackofficeExhibitorDetailComponent } from './pages/exhibitor-backoffice-exhibitor-detail/exhibitor-backoffice-exhibitor-detail.component';
import { ExhibitorBackofficeExhibitorProductsComponent } from './pages/exhibitor-backoffice-exhibitor-products/exhibitor-backoffice-exhibitor-products.component';
import { ExhibitorBackofficeExhibitorDetailAdminComponent } from './pages/exhibitor-backoffice-exhibitor-detail-admin/exhibitor-backoffice-exhibitor-detail-admin.component';
import { ExhibitorBackofficeExhibitorDetailAdminEditComponent } from './pages/exhibitor-backoffice-exhibitor-detail-admin-edit/exhibitor-backoffice-exhibitor-detail-admin-edit.component';
import { ExhibitorBackofficeProductDetailComponent } from './pages/exhibitor-backoffice-product-detail/exhibitor-backoffice-product-detail.component';
import { ExhibitorBackofficeProductDetailEditComponent } from './pages/exhibitor-backoffice-product-detail-edit/exhibitor-backoffice-product-detail-edit.component';
import { ExhibitorBackofficeExhibitorCreateComponent } from './pages/exhibitor-backoffice-exhibitor-create/exhibitor-backoffice-exhibitor-create.component';
import { LegalAdviceComponent } from './pages/legal-advice/legal-advice.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { AutoLoginComponent } from './pages/auto-login/auto-login.component';

const appRoutes: Routes = [
    {
        path: 'hall-list',
        component: HallListComponent,
        data: {title: 'Hall list page'}
    },
    {
      path: ":event",
      children: [
        { path: '', redirectTo: 'home', pathMatch: 'full'},
        { path: 'home', component: HomeComponent },
      ]
    },
    {
        path: ':catalogueId/:event/exhibitor/:id/detail',///barcelonawineweek/exhibitor/38627/detail?lang=es_ES
        component: CardDetailComponent,
    },
    {
        path: ':event/product/:productId/detail',///barcelonawineweek/exhibitor/38627/detail?lang=es_ES
        component: CardDetailProductComponent,
    },
    {
        path: ':event/firamaps',//firamaps?preserve=true&lang=es_ES
        component: MapsComponent,
    },
    {
        path: ':event/:catalogueId/profile',
        component: ProfileComponent,
        canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state)]
    },
    {
        path: ':event/:catalogueId/change-password',
        component: ChangePasswordComponent,
        canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state)]
    },
    {
        path: ':event/my-favorites',
        component: MyFavoritesComponent,
        canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state)]
    },
    {
        path: ':catalogueId/:exhibitorId/product/:cardId/detail',
        component: CardDetailProductComponent,
    },
    {
      path: ':event/exhibitor-backoffice/util-info',
        component: ExhibitorBackofficeUtilInfoComponent,
        canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state)]
    },
    {
      path: ':event/exhibitor-backoffice/exhibitors',
        component: ExhibitorBackofficeExhibitorsComponent,
        canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state)]
    },
    {
      path: ':event/exhibitor-backoffice/exhibitors/:exhibitorId/exhibitor-detail',
        component: ExhibitorBackofficeExhibitorDetailComponent,
        canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state)]
    },
    {
      path: ':event/exhibitor-backoffice/exhibitors/:exhibitorId/products/:productId/product-detail',
        component: ExhibitorBackofficeProductDetailComponent,
        canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state)]
    },
    {
      path: ':catalogueId/:event/exhibitor-backoffice/exhibitors/:exhibitorId/products/:productId/product-detail-edit',
        component: ExhibitorBackofficeProductDetailEditComponent,
        canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state)]
    },
    {
      path: ':event/exhibitor-backoffice/exhibitors/:exhibitorId/product-create',
        component: ExhibitorBackofficeProductDetailEditComponent,
        canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state)]
    },
    {
      path: ':event/exhibitor-backoffice/exhibitors/exhibitor-create',
        component: ExhibitorBackofficeExhibitorCreateComponent,
        canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state)]
    },
    {
      path: ':event/exhibitor-backoffice/exhibitors/:exhibitorId/exhibitor-detail-admin',
        component: ExhibitorBackofficeExhibitorDetailAdminComponent,
        canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state)]
    },
    {
      path: ':catalogueId/:event/exhibitor-backoffice/exhibitors/:exhibitorId/exhibitor-detail-admin-edit',
        component: ExhibitorBackofficeExhibitorDetailAdminEditComponent,
        canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state)]
    },
    {
        path: ':catalogueId/:event/exhibitor-backoffice/exhibitors/:exhibitorId/edit',///barcelonawineweek/exhibitor/38627/detail?lang=es_ES
        component: ExhibitorBackofficeExhibitorDetailEditComponent,
        canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state)]
    },
    {
        path: ':event/exhibitor-backoffice/exhibitors/:exhibitorId/edit',///barcelonawineweek/exhibitor/38627/detail?lang=es_ES
        component: ExhibitorBackofficeExhibitorDetailEditComponent,
        canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state)]
    },
    {
      path: ':event/exhibitor-backoffice/exhibitors/:exhibitorId/products',
        component: ExhibitorBackofficeExhibitorProductsComponent,
        canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state)]
    },
    {
      path: ':event/contact',
        component: ContactComponent,
    },
    {
      path: ':event/general-information',
        component: GeneralInformationComponent,
    },
    {
        path: ':event/auto-login/:userName/:token',
        component: AutoLoginComponent,
    },
    {
      path: ':event/legal-advice',
        component: LegalAdviceComponent,
    },
    {
      path: ':event/privacy-policy',
        component: PrivacyPolicyComponent,
    },
    {
        path: '',
        redirectTo: '/hall-list',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: '/hall-list',
        pathMatch: 'full'
    },
];

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule.forRoot(
            appRoutes,
            {enableTracing: false} // <-- Enable it for debuggin
        ),
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {
}

